<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import FileUpload from '../../../../components/ui/form/FileUpload.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, validateForm, resetForm, setFormData } = useFormValidation({
  profile_photo: props.data?.profile_photo || "",
    date_time: props.data?.date_time || "",
    user: props.data?.users_id || "",
    started_time: props.data?.started_time || "",
    scheduled_end: props.data?.scheduled_end || "",
    ended_time: props.data?.ended_time || "",
    outlet: props.data?.outlets_id || "",
    pos_station: props.data?.pos_stations_id || "",
    cancelled: props.data?.cancelled || false,
    uid: props.data?.uid || "",
})



const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})


</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div>
        <FileUpload
          accept=".pdf,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.dox,.docx,.html,.xml"
          label="User Photo"
          :max-size="5"
          :multiple="false"
          :readonly="isReadOnly"
          :image="true"
          path="brands"
          v-model="fields.profile_photo.value"
        />
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <TextInput
          v-model="fields.date_time.value"
          label="Date"
          :readonly="isReadOnly"
          :error="fields.date_time.touched ? fields.date_time.error : null"
          @blur="fields.date_time.touched = true"
        />

        <TextInput
          v-model="fields.user.value"
          label="User"
          :readonly="isReadOnly"
          :error="fields.user.touched ? fields.user.error : null"
          @blur="fields.user.touched = true"
        />

        <TextInput
          v-model="fields.started_time.value"
          label="Started Time"
          :readonly="isReadOnly"
          :error="
            fields.started_time.touched ? fields.started_time.error : null
          "
          @blur="fields.started_time.touched = true"
        />

        <TextInput
          v-model="fields.ended_time.value"
          label="Ended Time"
          :readonly="isReadOnly"
          :error="fields.ended_time.touched ? fields.ended_time.error : null"
          @blur="fields.ended_time.touched = true"
        />

        <TextInput
          v-model="fields.outlet.value"
          label="Outlet"
          :readonly="isReadOnly"
          :error="fields.outlet.touched ? fields.outlet.error : null"
          @blur="fields.outlet.touched = true"
        />

        <TextInput
          v-model="fields.pos_station.value"
          label="POS Station"
          :readonly="isReadOnly"
          :error="fields.pos_station.touched ? fields.pos_station.error : null"
          @blur="fields.pos_station.touched = true"
        />

        <CheckInput
          v-model="fields.cancelled.value"
          :readonly="isReadOnly"
          label="Cancelled"
          :error="fields.cancelled.touched ? fields.cancelled.error : null"
          @blur="fields.cancelled.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>